import { ArtifactRegistry } from "../artifacts/ArtifactDefinition";
import type { ArtifactDefinition } from "../artifacts/ArtifactDefinition";

export class ArtifactContentError extends Error {}

/** Builds the artifact registry from parsed `content/artifacts.json` — never hardcoded in TS. */
export function loadArtifactRegistry(data: unknown): ArtifactRegistry {
  if (!Array.isArray(data)) throw new ArtifactContentError("artifacts.json must be an array");
  const registry = new ArtifactRegistry();
  for (const raw of data) {
    if (typeof raw !== "object" || raw === null) throw new ArtifactContentError("Invalid artifact entry");
    const a = raw as Record<string, unknown>;
    if (
      typeof a["id"] !== "string" ||
      typeof a["title"] !== "string" ||
      typeof a["category"] !== "string" ||
      typeof a["asset"] !== "string" ||
      typeof a["rarity"] !== "string"
    ) {
      throw new ArtifactContentError(`Artifact missing required fields: ${JSON.stringify(raw)}`);
    }
    registry.register({
      id: a["id"],
      title: a["title"],
      category: a["category"] as ArtifactDefinition["category"],
      asset: a["asset"],
      rarity: a["rarity"] as ArtifactDefinition["rarity"],
      interactions: Array.isArray(a["interactions"]) ? (a["interactions"] as string[]) : [],
      knowledgeNodes: Array.isArray(a["knowledgeNodes"]) ? (a["knowledgeNodes"] as string[]) : [],
      ...(typeof a["revealsAs"] === "string" ? { revealsAs: a["revealsAs"] } : {}),
      ...(Array.isArray(a["relatedArtifacts"]) ? { relatedArtifacts: a["relatedArtifacts"] as string[] } : {}),
    } satisfies ArtifactDefinition);
  }
  return registry;
}
